import { render, staticRenderFns } from "./OpacityOverlay.vue?vue&type=template&id=a9927056&scoped=true&"
import script from "./OpacityOverlay.vue?vue&type=script&lang=js&"
export * from "./OpacityOverlay.vue?vue&type=script&lang=js&"
import style0 from "./OpacityOverlay.vue?vue&type=style&index=0&id=a9927056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9927056",
  null
  
)

export default component.exports